<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"

  type FilterOption = {
    value: string
    label: string
  }

  type FilterField = {
    id: string
    type?: "text" | "select" | "dateRange"
    placeholder: string
    value?: unknown
    options?: FilterOption[]
    enabled?: boolean
  }

  type Props = {
    fields: FilterField[]
    disabled?: boolean
    ariaLabel?: string
    maxFields?: number
    onChange: (fieldId: string, value: unknown) => void
  }

  let {
    fields,
    disabled = false,
    ariaLabel = "Tabelle filtern",
    maxFields = 3,
    onChange,
  }: Props = $props()

  const visibleFields = $derived(
    fields.filter((field) => field.enabled ?? true).slice(0, maxFields),
  )

  const eventValue = (event: Event): unknown => {
    const detail = (event as CustomEvent<{ value?: unknown }>).detail

    if (detail && "value" in detail) return detail.value

    return (event.target as HTMLInputElement | HTMLSelectElement | null)?.value ?? ""
  }
</script>

{#if visibleFields.length}
  <div class="batch-filter-bar form light" aria-label={ariaLabel}>
    <div class="row">
      {#each visibleFields as field (field.id)}
        <Input
          type={field.type ?? "text"}
          placeholder={field.placeholder}
          value={field.value ?? ""}
          options={field.options ?? []}
          {disabled}
          withTime={false}
          dateGranularity="day"
          onChange={(event) => onChange(field.id, eventValue(event))}
        />
      {/each}
    </div>
  </div>
{/if}

<style lang="less">
  .row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 0.75rem;
    align-items: end;
  }
</style>
